module.exports = __webpack_public_path__ + "static/img/Daniela-Galic.f0881cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniela-Galic.jpg
// module id = iXnM
// module chunks = 0